import $ from "jquery"
import TemplateView from "../TemplateView"
import {checkElementOrAncestorHasClass, registerOnClickOutside} from "../atBrowserUtils"
import {Moire} from "./Moire"
import {isEsc, onKeyDown} from '../keyHandlers/index'
import {shouldEventPreventHiding, shouldEventPreventHidingAllPanels} from "../panels/utils"
import ScrollUtils from '../util/ScrollUtils'
import {AtNextCustomScrollbarUsedClassName} from '../next/constants'

export default class PanelContainer extends TemplateView {
    constructor({
        component = null,
        additionalClass = "",
        onShowCallback = () => {},
        onHideCallback = () => {},
        onClickContentCallback = e => {},
        showAnimationClass = "",
        hideAnimationClass = "",
        showCopyLink = false,
        copyLinkTooltipText = '',
        showHideButton = false,
        hideOnEsc = false,
        hideOnClickOutside = {
            hideOnClick: false,
            outsideElement: $(document),
            panelType: "",
        },
        preventHidingCallback = () => false,
        showMoire,
        hideHandler = () => this.setState({isShown: false}),
        onCopyLinkClick = () => {},
        onClickCloseButton = () => {},
    }) {
        super();

        this.state = {
            isShown: false,
        };

        this.params = {
            component,
            additionalClass,
            onHideCallback,
            onShowCallback,
            onClickContentCallback,
            showAnimationClass,
            hideAnimationClass,
            showCopyLink,
            copyLinkTooltipText,
            showHideButton,
            hideOnEsc,
            hideOnClickOutside,
            preventHidingCallback,
            showMoire,
            hideHandler,
            onCopyLinkClick,
            onClickCloseButton,
        }

        this.onStatePropertyChanged('isShown', (isShown) => this.toggle(isShown));
    }

    templateHtml() {
        return "<div class='<%-additionalClass%> components_panelContainer'>" +
               "  <div class='content_panelContainer'/>" +
               "  <div class='copyLink_panelContainer' title='<%-copyLinkTooltipText%>'><%=copyLink%></div>" +
               "  <div class='hideButton_panelContainer'/>" +
               "</div>";
    }

    messageKeys() {
        return {
            copyLink: 'panel.common.copy_link',
        }
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            copyLinkTooltipText: this.params.copyLinkTooltipText,
        };
    }

    afterRender() {
        this.$el.click(this.params.onClickContentCallback)

        this.$content = this.find(".content_panelContainer")
        this.$hideButton = this.find(".hideButton_panelContainer")
        this.$copyLink = this.find(".copyLink_panelContainer")
        this.params.component.init(this.$content)

        if (this.params.showCopyLink) {
            this.$copyLink.click(() => this.params.onCopyLinkClick())
        } else {
            this.$copyLink.hide()
        }

        if (!this.params.showHideButton) {
            this.$hideButton.hide()
        } else {
            this.$hideButton.click(() => this.params.onClickCloseButton())
        }
        this.getEl().hide()

        this.params.component.stopHandlingStateChanges()

        this.$el.on(ScrollUtils.getWheelEventName(), e => {
            if (!checkElementOrAncestorHasClass(e.target, AtNextCustomScrollbarUsedClassName)) {
                e.preventDefault()
            }
        })
    }

    hide() {
        this.params.component.stopHandlingStateChanges()

        if (this.params.hideAnimationClass)
            this.$el.atAnimation().hideAnimated(this.params.hideAnimationClass);
        else
            this.$el.hide();

        if (this.params.hideOnEsc)
            this._unsubscribeEscapeEventListener();

        if (this.params.hideOnClickOutside.hideOnClick)
            this._unsubscribeOnOutsideClick();

        this.params.onHideCallback();

        if (this.params.showMoire) {
            Moire.getInstance().hide()
        }
    }

    show() {
        this.params.component.resumeHandlingStateChanges()

        if (this.params.showAnimationClass)
            this.$el.atAnimation().showAnimated(this.params.showAnimationClass);
        else
            this.$el.show();

        if (this.params.hideOnClickOutside.hideOnClick)
            this._subscribeOnOutsideClick();

        if (this.params.hideOnEsc)
            this._subscribeEscapeEventListener();

        this.params.onShowCallback();

        if (this.params.showMoire) {
            Moire.getInstance().show()
        }
    }

    _subscribeOnOutsideClick() {
        const config = this.params.hideOnClickOutside

        this._unsubscribeOnClickOutsideCb = registerOnClickOutside(
            this.$el,
            config.panelType,
            () => this.params.hideHandler(),
            (e) => {
                return this.params.preventHidingCallback(e) ||
                       shouldEventPreventHiding(e, config.panelType) ||
                       shouldEventPreventHidingAllPanels(e)
            },
            config.outsideElement,
        )
    }

    _unsubscribeOnOutsideClick() {
        if (this._unsubscribeOnClickOutsideCb)
            this._unsubscribeOnClickOutsideCb()
    }

    _unsubscribeEscapeEventListener() {
        if (this._restoreOldKeydownHandler)
            this._restoreOldKeydownHandler();
    }

    _subscribeEscapeEventListener() {
        this._restoreOldKeydownHandler = onKeyDown((keycode, e) => {
            if (isEsc(keycode)) {
                this.params.hideHandler()
                return true
            }
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/components/PanelContainer.js